import { useUpdateProjectStatusMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdateProjectStatus = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdateProjectStatusMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdateProjectStatus,
};
